import Countdown from "react-countdown";
import {memo} from "react";
import { ICountDown } from "interfaces";
import { secondsToHMS } from "helpers";
import dynamic from "next/dynamic";

const RotateLeftIcon = dynamic(() => import("../../icon-components/rotateLeftIcon"));

const CountDown = ({ resendCodeTime, setResendCodeTime, handleGenerateCode }: ICountDown) => {
    return (
        <Countdown
            key={Math.random()}
            date={Date.now() + (resendCodeTime * 1000)}
            intervalDelay={0}
            precision={3}
            renderer={props =>
                props.completed ?
                    <button className="pl-text-[14px] pl-font-bold pl-text-gray-500 dark:pl-text-dark-5" onClick={handleGenerateCode}>ارسال مجدد</button>
                    :
                    <div className="pl-flex pl-items-center pl-gap-2 !pl-h-[40px]">
                        <RotateLeftIcon className="pl-fill-gray-500 dark:pl-fill-dark-5" />
                        <p className="pl-text-[14px] pl-font-normal pl-text-gray-500 dark:pl-text-dark-5">ارسال کد فعال سازی بعد از <span className="pl-font-medium pl-text-main-light">{secondsToHMS(props.total / 1000)}</span></p>
                    </div>
            }
            onComplete={() => setResendCodeTime(0)}
        />
    )
}

export default memo(CountDown);